"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _getGoogleTag = _interopRequireDefault(require("./getGoogleTag"));

var _default = function _default(config) {
  var adUnits = config.adUnits,
      _config$pageLevelKeyV = config.pageLevelKeyValues,
      pageLevelKeyValues = _config$pageLevelKeyV === void 0 ? {} : _config$pageLevelKeyV;

  if (!adUnits.length) {
    return;
  }

  var googletag = (0, _getGoogleTag.default)(); // Set up each ad unit.

  adUnits.forEach(function (adUnit) {
    var sizes = adUnit.allowedAdSlotSizes || adUnit.sizes;
    googletag.cmd.push(function () {
      googletag.defineSlot(adUnit.adUnitId, sizes, adUnit.adId).addService(googletag.pubads());
    });
  });
  var keyValuePairs = Object.entries(pageLevelKeyValues);
  googletag.cmd.push(function () {
    keyValuePairs.forEach(function (_ref) {
      var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];

      return googletag.pubads().setTargeting(key, value);
    });
    googletag.pubads().enableSingleRequest();
    googletag.enableServices();
  });
};

exports.default = _default;